import React, { useEffect } from "react";
import { Mui, MuiIcons, MuiStyles } from "@osu/react-ui";
import { useLocation } from "react-router-dom";
import { COMMITTEE_COLOR_MAP } from "../../util/constants";
import Actions from "./Actions";
import useRoleAuthentication from "../../Common/hooks/useRoleAuthentication";

const chipLabelSx = {
  color: "black",
  display: "flex",
  alignItems: "center",
};


const ApplicantAppBar = (props) => {
  const { pageAppHeader } = props;
  const theme= MuiStyles.useTheme();
  const location = useLocation();
  const authDetails = useRoleAuthentication();
  const isTraining = location.pathname.includes('/training/')
  const isTrainingReport = location.pathname.includes('/reports/training/')

  useEffect(() => {
    window.dispatchEvent(new Event("scroll"));
  });

function ReviewChip({ approvalStage, stage, status, userId, reviewerEmployeeId, isReviewer }) {
  // Only show for stage 3 or 4, and only if all conditions are met
  const show =
    (Number(approvalStage) === 3 && Number(stage) === 3) ||
    (Number(approvalStage) === 4 && Number(stage) === 4);

  if (
    !show ||
    status !== "INPROGRESS" ||
    userId !== reviewerEmployeeId ||
    !isReviewer
  ) {
    return null;
  }

  // Setting chip color and label based on stage
  const chipProps = Number(approvalStage) === 3
    ? {
        color: 'rgb(194, 157, 224)',
        label: 'Third Review'
      }
    : {
        color: 'rgb(137, 225, 249)',
        label: 'Fourth Review'
      };

  return (
    <Mui.Chip
      style={{
        border: `1px solid ${chipProps.color}`,
        backgroundColor: chipProps.color,
        marginLeft: '1rem'
      }}
      label={
        <Mui.Typography sx={chipLabelSx} style={{ color: 'black' }}>
          {chipProps.label}
        </Mui.Typography>
      }
      variant="outlined"
    />
  );
}

  return (
  !isTrainingReport &&
    <Mui.Toolbar className="padding-y-1 display-flex justify-content-space-between align-items-center">
      {pageAppHeader.loading === true ? (
        <>
          <Mui.Skeleton variant="text" height={60} width="100%" />
        </>
      ) : (
        pageAppHeader?.name ? <>
          <Mui.Box style={{display: 'flex', flexDirection: 'column'}}>
            <Mui.Box style={{display: 'flex', flexDirection: 'row'}}>
              <Mui.Typography
                component="span"
                variant="h5"
              >
                {pageAppHeader?.name}
              </Mui.Typography>
              <Mui.Chip
                style={{
                  marginLeft: "1rem",
                  border: `1px solid ${
                    COMMITTEE_COLOR_MAP[pageAppHeader?.committee]
                  }`,
                }}
                label={
                  <Mui.Typography sx={chipLabelSx}>
                    <MuiIcons.FiberManualRecord
                      style={{
                        color: COMMITTEE_COLOR_MAP[pageAppHeader?.committee],
                        verticalAlign: "middle", // Add verticalAlign property
                      }}
                    />
                    {pageAppHeader?.committeeName}
                  </Mui.Typography>
                }
                variant="outlined"
              />
              {pageAppHeader?.priority && authDetails.ADMIN && <Mui.Chip
                style={{
                  backgroundColor: theme.palette.primary.main,
                  border: `1px solid ${theme.palette.primary.main}`,
                  marginLeft: '1rem'
                }}
                label={
                  <Mui.Typography sx={chipLabelSx} style={{color: 'white'}}>
                    Priority
                  </Mui.Typography>
                }
                 variant="filled"
              />}
              {isTraining && <Mui.Chip
                style={{
                  border: `1px solid orange`,
                  backgroundColor: 'orange',
                  marginLeft: '1rem'
                }}
                label={
                  <Mui.Typography sx={chipLabelSx} style={{color: 'black'}}>
                    Training
                  </Mui.Typography>
                }
                variant="outlined"
              />}
              {!isTraining && (
                <ReviewChip
                  approvalStage={pageAppHeader?.approvalStage}
                  stage={pageAppHeader?.stage}
                  status={pageAppHeader?.status}
                  userId={pageAppHeader?.userId}
                  reviewerEmployeeId={pageAppHeader?.reviewerEmployeeId}
                  isReviewer={pageAppHeader?.authDetails?.REVIEWER === true}
                />
             )}
            </Mui.Box>
            <Mui.Box>
              <Mui.Typography color="secondary">
                ID: {pageAppHeader?.emplId}
                {pageAppHeader?.dateOfBirth &&
                  " | " + "DOB: " + new Date(pageAppHeader?.dateOfBirth).toLocaleDateString()}
              </Mui.Typography>
            </Mui.Box>
        </Mui.Box>
          {!location?.pathname?.includes('view') &&
          <Actions pageAppHeader={pageAppHeader} isTraining={isTraining}/>
      }
        </> : <></>
      )}
    </Mui.Toolbar>
  );
};
export default ApplicantAppBar;
